(() => {
  const root = document.querySelector('[data-sb-coile-pdp-v2]');

  if (!root || root.dataset.ready === 'true') return;

  root.dataset.ready = 'true';

  const one = (selector, scope = root) => scope.querySelector(selector);
  const all = (selector, scope = root) => Array.from(scope.querySelectorAll(selector));

  const menuButton = one('[data-menu-toggle]');
  const menu = one('[data-mobile-menu]');

  const closeMenu = () => {
    if (!menuButton || !menu) return;
    menuButton.setAttribute('aria-expanded', 'false');
    menu.hidden = true;
  };

  if (menuButton && menu) {
    menuButton.addEventListener('click', () => {
      const open = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!open));
      menu.hidden = open;
    });

    all('a', menu).forEach((link) => link.addEventListener('click', closeMenu));
  }

  const gallery = one('[data-gallery]');

  if (gallery) {
    const slides = all('[data-gallery-slide]', gallery);
    const thumbs = all('[data-gallery-thumb]', gallery);
    const stage = one('[data-gallery-stage]', gallery);
    const thumbRail = one('[data-gallery-thumbs]', gallery);
    const counter = one('[data-gallery-current]', gallery);
    let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
    let pointerStartX = null;
    let pointerStartY = null;

    const loadSlideMedia = (slide) => {
      all('[data-src]', slide).forEach((media) => {
        const source = media.dataset.src;
        if (!source) return;
        media.src = source;
        media.removeAttribute('data-src');
        if (media.tagName === 'VIDEO') media.load();
      });
    };

    const showSlide = (index) => {
      if (!slides.length) return;
      activeIndex = (index + slides.length) % slides.length;

      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === activeIndex;
        slide.classList.toggle('is-active', active);
        slide.hidden = !active;
        slide.setAttribute('aria-hidden', String(!active));
        if (active) loadSlideMedia(slide);
        else all('video', slide).forEach((video) => video.pause());
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const active = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', active);
        thumb.setAttribute('aria-current', active ? 'true' : 'false');
        thumb.setAttribute('aria-selected', String(active));
        thumb.tabIndex = active ? 0 : -1;
      });

      if (counter) counter.textContent = String(activeIndex + 1);
      const selectedThumb = thumbs[activeIndex];
      if (selectedThumb && thumbRail) {
        const targetLeft = selectedThumb.offsetLeft - (thumbRail.clientWidth - selectedThumb.offsetWidth) / 2;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        thumbRail.scrollTo({ left: Math.max(0, targetLeft), behavior: reduceMotion ? 'auto' : 'smooth' });
      }
    };

    thumbs.forEach((thumb, index) => {
      thumb.addEventListener('click', () => showSlide(index));
      thumb.addEventListener('keydown', (event) => {
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + thumbs.length) % thumbs.length;
        else if (event.key === 'ArrowRight') nextIndex = (index + 1) % thumbs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = thumbs.length - 1;
        else return;
        event.preventDefault();
        showSlide(nextIndex);
        thumbs[nextIndex]?.focus();
      });
    });

    if (stage) {
      stage.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        showSlide(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
      });

      stage.addEventListener('pointerdown', (event) => {
        pointerStartX = event.clientX;
        pointerStartY = event.clientY;
      });

      stage.addEventListener('pointerup', (event) => {
        if (pointerStartX === null || pointerStartY === null) return;
        const distanceX = event.clientX - pointerStartX;
        const distanceY = event.clientY - pointerStartY;
        pointerStartX = null;
        pointerStartY = null;
        if (Math.abs(distanceX) <= Math.abs(distanceY) || Math.abs(distanceX) < 42) return;
        showSlide(activeIndex + (distanceX < 0 ? 1 : -1));
      });

      stage.addEventListener('pointercancel', () => {
        pointerStartX = null;
        pointerStartY = null;
      });
    }

    showSlide(activeIndex);
  }

  const activateTabs = (tabSelector, panelSelector, tabAttribute, panelAttribute, hideInactive) => {
    const tabs = all(tabSelector);
    const panels = all(panelSelector);

    tabs.forEach((tab, tabIndex) => {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      tab.addEventListener('click', () => {
        const target = tab.getAttribute(tabAttribute);
        tabs.forEach((candidate) => {
          const active = candidate === tab;
          candidate.classList.toggle('is-active', active);
          candidate.setAttribute('aria-selected', String(active));
          candidate.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          const active = panel.getAttribute(panelAttribute) === target;
          panel.classList.toggle('is-active', active);
          if (hideInactive) panel.hidden = !active;
        });
      });

      tab.addEventListener('keydown', (event) => {
        let nextIndex = tabIndex;
        if (event.key === 'ArrowLeft') nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        else if (event.key === 'ArrowRight') nextIndex = (tabIndex + 1) % tabs.length;
        else if (event.key === 'Home') nextIndex = 0;
        else if (event.key === 'End') nextIndex = tabs.length - 1;
        else return;
        event.preventDefault();
        tabs[nextIndex]?.focus();
        tabs[nextIndex]?.click();
      });
    });
  };

  activateTabs('[data-kit-thumb]', '[data-kit-panel]', 'data-kit-thumb', 'data-kit-panel', true);
  activateTabs('[data-use-tab]', '[data-use-panel]', 'data-use-tab', 'data-use-panel', false);

  const kitTabs = all('[data-kit-thumb]');
  const activeKitIndex = () => Math.max(0, kitTabs.findIndex((tab) => tab.classList.contains('is-active')));
  const activateKit = (index) => kitTabs[(index + kitTabs.length) % kitTabs.length]?.click();

  one('[data-kit-prev]')?.addEventListener('click', () => activateKit(activeKitIndex() - 1));
  one('[data-kit-next]')?.addEventListener('click', () => activateKit(activeKitIndex() + 1));

  all('.sb-coile__accordion article').forEach((item) => {
    const button = one('button[aria-expanded]', item);
    const answer = one('div', item);
    if (!button || !answer) return;

    button.addEventListener('click', () => {
      const opening = button.getAttribute('aria-expanded') !== 'true';

      all('.sb-coile__accordion article').forEach((candidate) => {
        const candidateButton = one('button[aria-expanded]', candidate);
        const candidateAnswer = one('div', candidate);
        candidateButton?.setAttribute('aria-expanded', 'false');
        if (candidateAnswer) candidateAnswer.hidden = true;
      });

      button.setAttribute('aria-expanded', String(opening));
      answer.hidden = !opening;
    });
  });

  all('[data-video-toggle]').forEach((toggle) => {
    const video = one('video', toggle);
    const icon = one('span', toggle);
    if (!video) return;

    const updateToggle = () => {
      toggle.setAttribute('aria-label', video.paused ? 'Play customer video' : 'Pause customer video');
      if (icon) icon.hidden = !video.paused;
    };

    toggle.addEventListener('click', () => {
      all('[data-video-toggle] video').forEach((candidate) => {
        if (candidate !== video) candidate.pause();
      });
      video.muted = false;
      if (video.paused) video.play().catch(() => undefined);
      else video.pause();
    });

    video.addEventListener('play', updateToggle);
    video.addEventListener('pause', updateToggle);
    video.addEventListener('ended', updateToggle);
    updateToggle();
  });

  if ('IntersectionObserver' in window) {
    const storyObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) entry.target.pause();
      });
    }, { threshold: 0.15 });
    all('[data-video-toggle] video').forEach((video) => storyObserver.observe(video));
  }

  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) return;
    all('video').forEach((video) => video.pause());
  });

  const productForm = one('.sb-coile__form');
  const primaryAtc = one('[data-primary-atc]');

  const submitProduct = () => {
    if (!productForm || !primaryAtc || primaryAtc.disabled) return;
    if (typeof productForm.requestSubmit === 'function') productForm.requestSubmit(primaryAtc);
    else primaryAtc.click();
  };

  all('[data-submit-offer]').forEach((button) => button.addEventListener('click', submitProduct));

  const sticky = one('[data-mobile-atc]');
  const finalClose = one('[data-final-close]');

  if (sticky && primaryAtc) {
    one('[data-sticky-atc]', sticky)?.addEventListener('click', submitProduct);
    sticky.hidden = false;

    let scheduled = false;

    const updateSticky = () => {
      scheduled = false;
      if (window.innerWidth > 749) {
        sticky.classList.remove('is-visible');
        return;
      }

      const primaryPassed = primaryAtc.getBoundingClientRect().bottom <= 0;
      const finalVisible = finalClose
        ? finalClose.getBoundingClientRect().top < window.innerHeight * 0.9
        : false;
      sticky.classList.toggle('is-visible', primaryPassed && !finalVisible);
    };

    const scheduleSticky = () => {
      if (scheduled) return;
      scheduled = true;
      if (typeof window.requestAnimationFrame === 'function') {
        window.requestAnimationFrame(updateSticky);
      } else {
        window.setTimeout(updateSticky, 16);
      }
    };

    window.addEventListener('scroll', scheduleSticky, { passive: true });
    window.addEventListener('resize', scheduleSticky, { passive: true });
    updateSticky();
  }
})();
